import { AdventuresState } from './types';

const createInitialAdventureDraft = () => ({
  id: null,
  adventureCategoryId: null,
  adventureCategoryImage: null,
  adventureCategoryName: null,
  adventureParentSupplies: [],
  adventureSitterSupplies: [],
  ageRangeText: null,
  ageRangeIds: [],
  description: null,
  duration: null,
  sitterAvailability: null,
  sitterPassion: null,
  surcharge: -1,
  title: null,
  status: null,
  edited: false,
});

const state: AdventuresState = {
  adventureDraft: createInitialAdventureDraft(),
  pendingEdits: {},
  flashMessage: undefined,
  previousRouteStack: [],
};

export default state;
